app.service('basketAnalytics', function (pageConfig, log, toCartError, basketAnalyticsFilter, price) {

	function paymentType() {
		return pageConfig.getData('order').isInstalmentPayment ? 'installment' : 'cash';
	}
	function warrantyType(warrantyPaymentType) {
		let type = paymentType();
		if (warrantyPaymentType == 'POSTPONED') {
			type = 'postponed';
		} else if (warrantyPaymentType == 'SUBSCRIPTION') {
			type = 'subscription';
		}
		return type
	}
	function logEvent(data) {
		log.event(data);
	}

	function logUA(data) {
		UA.push({ ecommerce: null });
		let value = 0;
		const items = Array.isArray(data.items) ? data.items : [data.items];

		items.forEach((item, index) => {
			const p = (item.price || 0) * (item.quantity || 1);
			if (p > 0) {
				value += p;
			}
			item.index = index;
		});
		UA.push({
			event: data.event,
			ecommerce: {
				currency: "PLN",
				value: price.number(value),
				items: items
			}
		});
	}

	function addWarranty({ productPlu, warrantyId, warrantyPaymentType, quantity, place }) {
		logEvent({
			id: 'to_cart',
			f03: 'cart_step_1',
			f04: warrantyId,
			f05: 'warranty',
			f06: productPlu,
			f07: place ? place : '',
			f08: 'fancybox',
			f09: 'new',
			f10: warrantyType(warrantyPaymentType)
		});
		const warrantyOldData = basketAnalyticsFilter.findWarrantyData({ plu: ('' + productPlu) });
		if (warrantyOldData && warrantyOldData.ua) {
			removeWarranty(productPlu, warrantyId, warrantyPaymentType);
		}
		// const warrantyDataUA = basketAnalyticsFilter.getWarrantyData({
		// 	id: warrantyId,
		// 	name: warrantyName,
		// 	category: 'Ubezpieczenie',
		// 	unitPrice: price.number(warrantyPrice),
		// 	quantity: quantity,
		// 	type: warrantyPaymentType,
		// }, {
		// 	plu: productPlu
		// });
		// logUA({
		// 	event: 'add_to_cart',
		// 	type: 'addWarranty',
		// 	items: warrantyDataUA
		// });
		const warrantyNewData = basketAnalyticsFilter.findData({ type: 'warranty', id: warrantyId, parentPlu: productPlu, warrantyType: warrantyPaymentType });
		if (warrantyNewData && warrantyNewData.length) {
			warrantyNewData[0].ua.quantity = quantity / 1;
			logUA({
				event: 'add_to_cart',
				type: 'addWarranty',
				items: warrantyNewData[0].ua
			});
		} else {
			console.log('Brak danych o aktualnie dodawanej gwarancji')
		}
	}
	function removeWarranty(productPlu, warrantyId, warrantyPaymentType) {
		logEvent({
			id: 'remove_cart',
			f03: 'cart_step_1',
			f04: warrantyId,
			f05: 'warranty',
			f06: productPlu,
			f07: 'warranty_details',
			f08: 'fancybox',
			f09: 'new',
			f10: warrantyType(warrantyPaymentType)
		});
		const warrantyData = basketAnalyticsFilter.findWarrantyData({ plu: ('' + productPlu) });
		if (warrantyData && warrantyData.ua) {
			logUA({
				event: 'remove_from_cart',
				type: 'removeWarranty',
				items: warrantyData.ua
			});
		}
	}
	function addAccessory(accessoryPlu, parentPlu, type) {
		logEvent({
			id: 'to_cart',
			f03: 'cart_step_1',
			f04: accessoryPlu,
			f05: 'akc',
			f06: parentPlu,
			f07: 'accessory_card',
			f08: type,
			f09: 'new',
			f10: paymentType()
		});
		const parentProduct = basketAnalyticsFilter.findProductData({ plu: parentPlu });
		if (parentProduct && parentProduct.raw) {
			// const accessoryProduct = basketAnalyticsFilter.findAccessoryData({ id: productId });

			// if (accessoryProduct) {
			// 	logUA({
			// 		event: 'add_to_cart',
			// 		type: 'addAccessory',
			// 		items: accessoryProduct
			// 	});
			// }
		}
	}
	function shopEventPriceFormat(price) {
		return price.toString().replace(' ', '');
	}
	function removeAccessory(accessoryPlu, productPlu) {
		const accessoryData = basketAnalyticsFilter.findProductData({ plu: accessoryPlu });
		if (accessoryData && accessoryData.raw) {
			logEvent({
				id: 'remove_cart',
				f03: 'K0',
				f04: accessoryPlu,
				f05: 'akc',
				f06: productPlu,
				f07: 'accessory_card',
				f08: 'button',
				f09: 'new',
				f10: paymentType(),
				f12: shopEventPriceFormat(accessoryData.raw.unitPrice)
			});
			logUA({
				event: 'remove_from_cart',
				type: 'removeAccessory',
				items: accessoryData.ua
			});
		}
	}
	function updateService(productPlu, servicePlu, quantity) {			// update czyli zmniejszenie ilości, zwiększenie ilości dzieje się przez "add"
		const serviceData = basketAnalyticsFilter.findServiceData({ plu: servicePlu, parentPlu: productPlu }, { plu: productPlu });
		if (serviceData?.raw) {
			const oldQuantity = serviceData.raw.quantity;
			if (oldQuantity > quantity) {
				removeService({ productPlu, servicePlu, quantity: oldQuantity - quantity });
			} else if (oldQuantity < quantity) {
				addService({ productPlu, servicePlu, quantity: quantity - oldQuantity });
			} else {
				console.log('Wg danych nie odnotowany różnicy')
			}
		} else {
			console.log('Nie znaleziono danych analitycznych dla usługi', servicePlu, 'dla produktu', productPlu);
		}

	}
	function removeService({ productPlu, servicePlu, quantity }) {
		logEvent({
			id: 'remove_cart',
			f03: 'cart_step_1',
			f04: servicePlu,
			f05: 'service',
			f06: productPlu,
			f07: 'services_details',
			f08: 'fancybox',
			f09: 'new',
			f10: paymentType()
		});
		const serviceData = basketAnalyticsFilter.findServiceData({ plu: servicePlu, parentPlu: productPlu }, { plu: productPlu }, { quantity: quantity });
		if (serviceData && serviceData.ua) {
			logUA({
				event: 'remove_from_cart',
				type: 'removeService',
				items: serviceData.ua
			});
		};
	}
	function addService({ productPlu, servicePlu, place, quantity = 1 }) {
		logEvent({
			id: 'to_cart',
			f03: 'cart_step_1',
			f04: servicePlu,
			f05: 'service',
			f06: productPlu,
			f07: place,
			f08: 'fancybox',
			f09: 'new',
			f10: paymentType()
		});
		const serviceData = basketAnalyticsFilter.findServiceData({ plu: servicePlu, parentPlu: productPlu }, { plu: productPlu }, { quantity: quantity });
		if (serviceData?.ua) {
			logUA({
				event: 'add_to_cart',
				type: 'addService',
				items: serviceData.ua
			});
		} else {
			console.log('Nie znaleziono danych analitycznych dla usługi', servicePlu, 'dla produktu', productPlu);
		}
	}
	function addRelatedAccessory({ productId, parentId, place }) {
		const parentProduct = basketAnalyticsFilter.findProductData({ id: parentId });
		if (parentProduct && parentProduct.raw) {
			const relatedProduct = basketAnalyticsFilter.findRelatedProductData({ id: parentId }, { id: productId });

			if (relatedProduct?.raw) {
				if (place == 'fancybox') {
					relatedProduct.ua.item_list_name = 'Koszyk - Rekomendowane akcesoria – warstwa';
					relatedProduct.ua.item_list_id = 'cart_recommended_accessories_layer';
				} else {
					relatedProduct.ua.item_list_name = 'Koszyk - Rekomendowane akcesoria';
					relatedProduct.ua.item_list_id = 'cart_recommended_accessories';
				}
				logEvent({
					id: 'to_cart',
					f03: 'cart_step_1',
					f04: relatedProduct.raw.plu,
					f05: 'akc',
					f06: parentProduct.raw.plu,
					f07: 'accessory_card',
					f08: place,
					f09: 'new',
					f10: paymentType(),
					f12: shopEventPriceFormat(relatedProduct.raw.unitPrice)
				});

				logUA({
					event: 'add_to_cart',
					type: 'addRelatedAccessory',
					items: relatedProduct.ua
				});
			}
		} else {
			console.log('Nie znaleziono danych analitycznych dla produktu', productId, 'dla rodzica', parentId);
		}
	}
	function addPartnerSubscription(productPlu, partnerSubscriptionId, quantity = 1) {
		logEvent({
			id: 'to_cart',
			f03: 'cart_step_1',
			f04: partnerSubscriptionId,
			f05: 'service',
			f06: productPlu,
			f07: 'services_details',
			f08: 'fancybox',
			f09: 'new',
			f10: 'subscription'
		});

		logUA({
			event: 'add_to_cart',
			type: 'addPartnerSubscription',
			items: {
				name: 'dane do uzupełnienia',
				dimension31: 'Usługa partnerska',
				quantity: quantity,
				partnerSubscriptionId: partnerSubscriptionId,
				parentPlu: productPlu
			}
		});
	}
	function quantityPartnerSubscription(partnerSubscriptionId, productId, newQuantity) {
		const parentProduct = basketAnalyticsFilter.findProductData({ id: productId });
		const partnerSubscriptionData = basketAnalyticsFilter.findPartnerSubscriptionData({ id: productId }, { id: partnerSubscriptionId });
		if (partnerSubscriptionData && partnerSubscriptionData.raw) {
			if (newQuantity > partnerSubscriptionData.raw.quantity) {
				addPartnerSubscription(productId, partnerSubscriptionId, newQuantity - partnerSubscriptionData.raw.quantity);
			} else {
				removePartnerSubscription(productId, partnerSubscriptionId, partnerSubscriptionData.raw.quantity - newQuantity);
			}
		}
	}

	function removePartnerSubscription(productId, partnerSubscriptionId, quantity) {
		const parentProduct = basketAnalyticsFilter.findProductData({ id: productId });
		if (parentProduct && parentProduct.raw) {
			logEvent({
				id: 'remove_cart',
				f03: 'cart_step_1',
				f04: partnerSubscriptionId,
				f05: 'service',
				f06: parentProduct.raw.plu,
				f07: 'service_details',
				f08: 'fancybox',
				f09: 'new',
				f10: 'subscription'
			});
			const partnerSubscriptionData = basketAnalyticsFilter.findPartnerSubscriptionData({ id: productId }, { id: partnerSubscriptionId }, { quantity: quantity });
			if (partnerSubscriptionData) {
				logUA({
					event: 'remove_from_cart',
					type: 'removePartnerSubscription',
					items: partnerSubscriptionData.ua
				});
			}
		} else {
			console.log('Nie znaleziono danych analitycznych dla produktu', productId, 'dla usługi partnerskiej', partnerSubscriptionId);
		}
	}
	function addDependentProduct(productPlu, parentPlu, place) {
		const dependentProduct = basketAnalyticsFilter.findDependentProductData({ plu: parentPlu });
		if (dependentProduct && dependentProduct.ua) {
			logEvent({
				id: 'to_cart',
				f03: 'cart_step_1',
				f04: productPlu, 	//plu folijki
				f05: 'product',
				f06: parentPlu, // plu rodzica
				f07: place,	//miejsce
				f08: place == 'service_details' ? 'fancybox' : 'button',	//miejsce dodania
				f09: 'new',
				f10: paymentType(),
				f12: shopEventPriceFormat(dependentProduct.raw.unitPrice)
			});

			logUA({
				event: 'add_to_cart',
				type: 'addDependentProduct',
				items: dependentProduct.ua
			});
		}
	}
	function promotionClick(promotionName, promotionUrl) {
		UA.push({
			'event': 'click_promotion',
			'promotion_name': promotionName,
			'creative_name': 'Promocja na koszyku',
			'promotion_url': promotionUrl
		});
		logEvent({
			id: 'click_promotion',
			f04: promotionUrl,
			f05: promotionName,
			f06: 'cart_step_1',
			f07: 'Promocja na koszyku'
		});
	}
	function addItem({ itemId, quantity, warrantyChanged }) {
		const productData = basketAnalyticsFilter.findProductData({ cartId: itemId });
		if (productData && productData.raw) {
			for (let i = 1; i <= quantity; i++) {
				logEvent({
					id: 'to_cart',
					f03: 'cart_step_1',
					f04: productData.raw.plu,
					f05: 'product',
					f06: '',
					f07: 'leaf',
					f08: 'button',
					f09: productData.raw.isOutlet ? 'outlet' : 'new',
					f10: productData.raw.isInstalmentPrice ? 'installment' : 'cash',
					f11: productData.raw.packageCode ? productData.raw.packageCode : '',
					f12: shopEventPriceFormat(productData.raw.unitPrice)
				});
			}
			productData.ua.quantity = quantity;
			const items = [productData.ua];

			if (warrantyChanged && productData.raw.warranty.length) {
				const warrantyData = basketAnalyticsFilter.findWarrantyData({ plu: productData.raw.plu });
				if (warrantyData && warrantyData.ua) {
					warrantyData.ua.quantity = quantity;
					items.push(warrantyData.ua);
				}
			}
			const packageCode = '' + productData.raw.packageCode;
			if (packageCode && packageCode.length) {
				const suiteData = basketAnalyticsFilter.findProductsData({ packageCode: packageCode });
				if (suiteData && suiteData.length) {
					suiteData.forEach(suiteItem => {
						if (suiteItem.raw.cartId != itemId) {
							for (let i = 1; i <= quantity; i++) {
								logEvent({
									id: 'to_cart',
									f03: 'cart_step_1',
									f04: suiteItem.raw.plu,
									f05: 'akc',
									f06: productData.raw.plu,
									f07: 'leaf',
									f08: 'button',
									f09: suiteItem.raw.isOutlet ? 'outlet' : 'new',
									f10: suiteItem.raw.isInstalmentPrice ? 'installment' : 'cash',
									f11: packageCode,
									f12: shopEventPriceFormat(suiteItem.raw.unitPrice)
								});
							}
							suiteItem.ua.quantity = quantity;
							items.push(suiteItem.ua);
						}
					});
				}
			}
			logUA({
				event: 'add_to_cart',
				type: 'addItem',
				items: items
			});

		}
	}
	function removeItem({ itemId, quantity }) {	// quantity ilość usuwanych produktów, jeśli nie podana to wszystkie
		let productData = basketAnalyticsFilter.findProductData({ cartId: itemId });
		if (productData && productData.raw) {
			let startProductQuantity = productData.ua.quantity;
			if (!quantity) {
				quantity = productData.ua.quantity;
			} else {
				productData.ua.quantity = quantity;
			}
			for (let i = 1; i <= quantity; i++) {
				logEvent({
					id: 'remove_cart',
					f03: 'cart_step_1',
					f04: productData.raw.plu,
					f05: 'product',
					f06: '',
					f07: 'leaf',
					f08: 'button',
					f09: productData.raw.isOutlet ? 'outlet' : 'new',
					f10: productData.raw.isInstalmentPrice ? 'installment' : 'cash',
					f11: productData.raw.packageCode ? productData.raw.packageCode : '',
					f12: shopEventPriceFormat(productData.raw.unitPrice)
				});
			}
			const items = [productData.ua];

			if (productData.raw.warranty.length) {
				const warrantyData = basketAnalyticsFilter.findWarrantyData({ plu: productData.raw.plu });
				if (warrantyData && warrantyData.ua) {
					if (warrantyData.raw.quantity === startProductQuantity) {
						warrantyData.ua.quantity = quantity;
						items.push(warrantyData.ua);	// może się zdarzyć że są dwa produkty a tylko jedna gwarancja, więc wysyłka jest tylko wtedy jak ilość produktów == ilość gwarancji
					}
				}
			}
			const servicesListData = basketAnalyticsFilter.findServicesData({ plu: productData.raw.plu });
			if (servicesListData && servicesListData.length) {
				servicesListData.forEach(serviceData => {
					serviceData.ua.quantity = Math.min(serviceData.ua.quantity, quantity);
					items.push(serviceData.ua);
				});
			};
			const packageCode = '' + productData.raw.packageCode;
			if (packageCode && packageCode.length) {
				const suiteData = basketAnalyticsFilter.findProductsData({ packageCode: packageCode });
				if (suiteData && suiteData.length) {
					suiteData.forEach(suiteItem => {
						if (suiteItem.raw.cartId != itemId) {
							suiteItem.ua.quantity = quantity;
							for (let i = 1; i <= quantity; i++) {
								logEvent({
									id: 'remove_cart',
									f03: 'cart_step_1',
									f04: suiteItem.raw.plu,
									f05: 'akc',
									f06: productData.raw.plu,
									f07: 'leaf',
									f08: 'button',
									f09: suiteItem.raw.isOutlet ? 'outlet' : 'new',
									f10: suiteItem.raw.isInstalmentPrice ? 'installment' : 'cash',
									f11: packageCode,
									f12: shopEventPriceFormat(suiteItem.raw.unitPrice)
								});
							}
							items.push(suiteItem.ua);
						}
					});
				}
			}
			logUA({
				event: 'remove_from_cart',
				type: 'removeItem',
				items: items
			});
		}
	}
	function changeQuantity({ itemId, quantity, warrantyChanged }) {
		const basket = pageConfig.getData('basket');
		let basketItem = basket.items.filter((i) => i.cartId == itemId);
		const startProductQuantity = basketItem.length ? basketItem[0].quantity : 0;
		if (basketItem && basketItem.length) {
			if (quantity > startProductQuantity) {
				addItem({
					itemId: itemId,
					quantity: Math.abs(quantity - startProductQuantity),
					warrantyChanged: warrantyChanged
				});
			} else {
				removeItem({
					itemId: itemId,
					quantity: Math.abs(quantity - startProductQuantity)
				});
			}
		} else {
			console.log('Brak itema w koszyku');
		}
	}

	function addProductErrorInit(errorMessage) {
		const basket = pageConfig.getData('order');
		if (!basket || !basket.cartStepOrderInfo) {
			return;
		}

		const info = basket.cartStepOrderInfo;
		const productStatus = info.outletWarehouseCode ? 'outlet' : 'new';
		const paymentType = info.isInstalment === 'true' ? 'installment' : 'cash';
		const isOperatorMode = pageConfig.isOperatorMode;

		toCartError.sendEventAddToCartError({
			productId: info.productsCodes,
			productStatus,
			paymentType,
			errorMessage,
			isOperatorMode,
		});
	}

	function addProductError(itemId, errorMessage) {
		const basket = pageConfig.getData('basket');
		if (!basket || !basket.items) {
			return;
		}

		const productInfo = basket.items.find(item => item.cartId === itemId);
		if (!productInfo) {
			return;
		}

		const productStatus = productInfo.isOutlet ? 'outlet' : 'new';
		const isOperatorMode = pageConfig.isOperatorMode;

		toCartError.sendEventAddToCartError({
			productId: productInfo.plu,
			productStatus,
			paymentType: paymentType(),
			errorMessage,
			isOperatorMode
		});
	}
	function sendAll() {
		logUA({
			event: 'view_cart',
			type: 'all',
			items: basketAnalyticsFilter.all()
		})
	}

	function addProduct(productPlu, place) {
		logEvent({
			id: 'to_cart',
			f03: 'cart_step_1',
			f04: productPlu,
			f05: 'product',
			f07: place,	//miejsce
			f08: place,	//miejsce dodania
			f09: 'new',
			f10: paymentType()
		});
		const productData = basketAnalyticsFilter.findData({ type: 'product', plu: productPlu });
		if (productData?.[0]?.ua) {
			logUA({
				event: 'add_to_cart',
				type: 'addItem',
				items: Object.assign(productData[0].ua, {
					item_list_name: place == 'accessory_card_search' || place == 'accessory_card' ? 'Koszyk - Akcesoria' : place,
					item_list_id: place == 'accessory_card_search' || place == 'accessory_card' ? 'cart_accessories' : place,
				})
			});
		} else {
			console.log('Nie znaleziono danych analitycznych dla produktu', productPlu);
		}
	}

	return {
		changeQuantity,
		removeItem,
		addProduct,
		addProductError,
		addProductErrorInit,
		addService,
		updateService,
		removeService,
		removeAccessory,
		addAccessory,
		addPartnerSubscription,
		quantityPartnerSubscription,
		removePartnerSubscription,
		addWarranty,
		removeWarranty,
		addRelatedAccessory,
		addDependentProduct,
		paymentType,
		promotionClick,
		sendAll
	};
});
